// let navBtn = document.getElementById('navBtn');
// let navBar = document.getElementById('sidenav');

// navBtn.addEventListener('click', function() {
//     navBar.classList.toggle('outfield');
//     navBar.classList.toggle('slide-in-sidenav');
//     navBtn.classList.toggle('slide-in-nav');
// });

// SLIDE MENU

$('#menu-action').click(function() {
  $('.sidebar').toggleClass('active');
  $('.main').toggleClass('active');
  $(this).toggleClass('active');

  if ($('.sidebar').hasClass('active')) {
    $(this).find('i').addClass('la-times');
    $(this).find('i').removeClass('la-bars');
  } else {
    $(this).find('i').addClass('la-bars');
    $(this).find('i').removeClass('la-times');
  }
});

// Add hover feedback on menu
$('#menu-action').hover(function() {
    $('.sidebar').toggleClass('hovered');
});

// Infos hover (i)

let infoBulle = document.getElementById('infoBulle');
let infoBulleContent = document.getElementById('infoBulleContent');

infoBulle.addEventListener('mouseover', function() {
  infoBulleContent.style.display = "block";
});
infoBulle.addEventListener('mouseout', function() {
  infoBulleContent.style.display = "none";
});


// Menu dropdown

const dropDownItems = document.querySelectorAll(".sidebar__list");

dropDownItems.forEach(el => {
  el.addEventListener("click", function() {
    el.classList.toggle("dropdown-active");
  })
});

document.querySelector("#sidebar").addEventListener("mouseleave", function() {
  dropDownItems.forEach(el => {
    el.classList.remove("dropdown-active");
  });
});